import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useToast } from "../components/Toast";
import { Button } from "../components/Button";
import { TextField } from "../components/TextField";
import { requestPasswordReset } from "../api/auth";
import { errorMessage } from "../api/client";

/**
 * Public "forgot password" screen. The backend always returns 200 (never reveals
 * whether the email exists), so we show the same success state regardless.
 */
export function ForgotPasswordPage() {
  const { t } = useTranslation();
  const toast = useToast();

  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await requestPasswordReset({ email });
      setSent(true);
    } catch (err) {
      toast.error(errorMessage(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-screen">
      <form className="auth-card stack" onSubmit={onSubmit}>
        <h1>{t("forgotPassword.title")}</h1>
        {sent ? (
          <>
            <p className="muted" style={{ textAlign: "center", marginTop: "-8px" }}>
              {t("forgotPassword.sent")}
            </p>
            <p className="faint" style={{ textAlign: "center", margin: 0 }}>
              <Link to="/login">{t("forgotPassword.backToLogin")}</Link>
            </p>
          </>
        ) : (
          <>
            <p className="muted" style={{ textAlign: "center", marginTop: "-8px" }}>
              {t("forgotPassword.subtitle")}
            </p>
            <TextField
              label={t("auth.email")}
              type="email"
              autoComplete="username"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t("auth.emailPlaceholder")}
            />
            <Button type="submit" variant="primary" loading={submitting} disabled={!email}>
              {t("forgotPassword.submit")}
            </Button>
            <p className="faint" style={{ textAlign: "center", margin: 0 }}>
              <Link to="/login">{t("forgotPassword.backToLogin")}</Link>
            </p>
          </>
        )}
      </form>
    </div>
  );
}
